"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoadoutManager = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const osrs_sdk_1 = require("osrs-sdk");
const Modal_1 = require("./Modal");
const RuneScapeButton_1 = require("./RuneScapeButton");
const RuneScapePanel_1 = require("./RuneScapePanel");
const Loadout_1 = require("./Loadout");
const TrainerContext_1 = require("../TrainerContext");
function LoadoutManager({ getSubstitutes, loadouts, onClose, open }) {
    var _a, _b;
    const trainer = (0, TrainerContext_1.useTrainerContext)();
    const settings = osrs_sdk_1.Settings.getSnapshot();
    const savedLoadoutIndex = loadouts.findIndex((template) => template.name === settings.loadout);
    const savedCustomLoadout = ((_a = settings.customLoadout) === null || _a === void 0 ? void 0 : _a.name) === ((_b = loadouts[savedLoadoutIndex]) === null || _b === void 0 ? void 0 : _b.name)
        ? settings.customLoadout
        : null;
    const [selectedLoadoutIndex, setSelectedLoadoutIndex] = (0, react_1.useState)(savedLoadoutIndex >= 0 ? savedLoadoutIndex : 0);
    const [loadout, setLoadout] = (0, react_1.useState)(savedCustomLoadout !== null && savedCustomLoadout !== void 0 ? savedCustomLoadout : loadouts[savedLoadoutIndex >= 0 ? savedLoadoutIndex : 0]);
    const [isCustomLoadout, setIsCustomLoadout] = (0, react_1.useState)(savedCustomLoadout !== null);
    const [registry, setRegistry] = (0, react_1.useState)();
    const [hasPendingChanges, setHasPendingChanges] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (!open || registry)
            return;
        let mounted = true;
        // The registry imports and constructs every item class, so keep it out of
        // the initial app bundle and load it only when the loadout UI is opened.
        (0, osrs_sdk_1.loadLoadoutRegistry)().then((loadedRegistry) => {
            if (mounted)
                setRegistry(loadedRegistry);
        });
        return () => {
            mounted = false;
        };
    }, [open, registry]);
    // Selecting something from the dropdown resets to a base loadout and clears custom state.
    const onSelectTemplatedLoadout = (event) => {
        if (event.currentTarget.value === "custom")
            return;
        const nextIndex = Number(event.currentTarget.value);
        const nextLoadout = loadouts[nextIndex];
        if (!nextLoadout)
            return;
        setSelectedLoadoutIndex(nextIndex);
        setLoadout(nextLoadout);
        setIsCustomLoadout(false);
        setHasPendingChanges(true);
        osrs_sdk_1.Settings.set({ loadout: nextLoadout.name, customLoadout: null });
    };
    // Change a specific slot, including the opposing slot for two-handed weapons.
    const onItemSelect = (slot, itemId) => {
        if (!loadout)
            return;
        const selectedItem = itemId === null ? undefined : registry === null || registry === void 0 ? void 0 : registry.get(itemId);
        const currentWeapon = loadout.equipment.weapon === null
            ? undefined
            : registry === null || registry === void 0 ? void 0 : registry.get(loadout.equipment.weapon);
        const equipsTwoHandedWeapon = slot.kind === "equipment"
            && slot.slot === "weapon"
            && selectedItem instanceof osrs_sdk_1.Weapon
            && selectedItem.isTwoHander;
        const replacesTwoHandedWeapon = slot.kind === "equipment"
            && slot.slot === "offhand"
            && currentWeapon instanceof osrs_sdk_1.Weapon
            && currentWeapon.isTwoHander;
        const nextLoadout = slot.kind === "equipment"
            ? {
                ...loadout,
                equipment: {
                    ...loadout.equipment,
                    [slot.slot]: itemId,
                    ...(equipsTwoHandedWeapon ? { offhand: null } : {}),
                    ...(replacesTwoHandedWeapon ? { weapon: null } : {}),
                },
            }
            : (() => {
                const inventory = [...loadout.inventory];
                inventory[slot.index] = itemId;
                return { ...loadout, inventory };
            })();
        setLoadout(nextLoadout);
        setIsCustomLoadout(true);
        setHasPendingChanges(true);
        osrs_sdk_1.Settings.set({ loadout: nextLoadout.name, customLoadout: nextLoadout });
    };
    const close = () => {
        if (hasPendingChanges) {
            trainer.reset();
            setHasPendingChanges(false);
        }
        onClose();
    };
    const getLoadoutSubstitutes = (slot, currentRegistry) => {
        if (getSubstitutes)
            return getSubstitutes(slot, currentRegistry);
        if (!currentRegistry)
            return [];
        if (slot === null)
            return Array.from(currentRegistry.keys());
        return Array.from(currentRegistry.entries())
            .filter(([, item]) => item instanceof osrs_sdk_1.Equipment && osrs_sdk_1.EQUIPMENT_TYPE_TO_SLOT[item.type] === slot)
            .map(([itemId]) => itemId);
    };
    return ((0, jsx_runtime_1.jsx)(Modal_1.Modal, { open: open, children: (0, jsx_runtime_1.jsxs)(RuneScapePanel_1.RuneScapePanel, { style: {
                minWidth: 320,
            }, children: [(0, jsx_runtime_1.jsx)("h2", { children: "Loadout" }), loadouts.length > 0 ? ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "loadout-select", children: "Template: " }), (0, jsx_runtime_1.jsxs)("select", { id: "loadout-select", value: isCustomLoadout ? "custom" : String(selectedLoadoutIndex), onChange: onSelectTemplatedLoadout, children: [isCustomLoadout && (0, jsx_runtime_1.jsx)("option", { value: "custom", children: "Custom*" }), loadouts.map((template, index) => ((0, jsx_runtime_1.jsx)("option", { value: index, children: template.name }, template.name)))] }), loadout && ((0, jsx_runtime_1.jsx)(Loadout_1.Loadout, { getSubstitutes: getLoadoutSubstitutes, loadout: loadout, onItemSelect: onItemSelect, registry: registry }))] })) : ((0, jsx_runtime_1.jsx)("p", { children: "No loadout templates configured." })), (0, jsx_runtime_1.jsx)(RuneScapeButton_1.RuneScapeButton, { type: "button", onClick: close, children: hasPendingChanges ? "Close + Reset" : "Close" })] }) }));
}
exports.LoadoutManager = LoadoutManager;
